/** Proudly human-made, for people @author Erik Vroon */
import {LightDocumentObjectModelNexusComponent} from "../modules/light-document-object-model-nexus-component";
import {svg, html, css, LitElement} from 'lit';
import {HighContrastModule} from "../modules/high-contrast.module";
import {StorageModule} from '../modules/storage.module';
import {DocumentLanguageModule} from '../modules/document-language.module';
import { FeedbackModule } from '../modules/feedback.module.js';
import { FloatingActionButtonComponent } from '../components/floating-action-button.component';
import { InternationalTextToSpeechModule } from "../modules/international-text-to-speech.module";

export class InternationalFloatingActionButtonComponent extends FloatingActionButtonComponent {

    accessibilityTextToSpeechState = 'inactive'; // not needed but for clarity and being explicit about it

    handleTextToSpeechFirstUpdated() {
        this.accessibilityTextToSpeechState = 'inactive'; // keep it inactive cuz languages may be non-english.
        // sidestepping the logic for this variant of the tts model, just do not load stuff furthjer
        // TODO: would need some more translations logic to match voices correctly to language!
    }

    setTextToSpeechModule() {
        this.textToSpeechModule = new InternationalTextToSpeechModule();
    }

    handleTextToSpeech() {
        console.log('handleTextToSpeech', this.accessibilityTextToSpeechState);
        switch (this.accessibilityTextToSpeechState) {
            case 'active':
                this.accessibilityTextToSpeechState = 'inactive';
                // TODO: disable speaking in this case
                this.textToSpeechModule.handleDeactivation();
                window.speechSynthesis.cancel(); // cancel utterance
                this.storageModule.setItem('localStorage', 'text-to-speech', '0');
                break;
            case 'inactive':
                this.textToSpeechModule.handleActivation();
                this.textToSpeechModule.introduce();
                this.accessibilityTextToSpeechState = 'active';
                this.storageModule.setItem('localStorage', 'text-to-speech', '1');
                break;
            default:
                break;
        }
        this.requestUpdate();
    }

}

window.customElements.define('nexus-international-floating-action-button', InternationalFloatingActionButtonComponent);